/**
 * useScrubber
 * ───────────
 * Controls the lineage scrubber panel that slides up from the bottom.
 *
 * State:
 *   - showScrubber  (visible or not)
 *   - scrubberLineage[]  (ordered project chain for the scrubber to render)
 *
 * Place at: src/hooks/useScrubber.js
 */

import { useState, useCallback } from 'react';

export default function useScrubber() {
  const [showScrubber, setShowScrubber] = useState(false);
  const [scrubberLineage, setScrubberLineage] = useState([]);

  const openScrubber = useCallback((lineageChain) => {
    if (lineageChain && lineageChain.length >= 1) {
      setScrubberLineage(lineageChain);
      setShowScrubber(true);
    }
  }, []);

  const closeScrubber = useCallback(() => {
    setShowScrubber(false);
  }, []);

  return {
    showScrubber,
    scrubberLineage,
    openScrubber,
    closeScrubber,
    setShowScrubber,
    setScrubberLineage,
  };
}